import { Directive, inject, input, InputSignal, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { ProductPricesModel } from '@libs/shop/models';
import { ProductPriceVisibilityService } from './product-price-visibility.service';

@Directive({
  selector: 'ng-template[uiProductPriceVisibility]',
})
export class ProductPriceVisibilityDirective implements OnInit {
  public prices: InputSignal<ProductPricesModel | undefined> = input.required();
  private readonly templateRef: TemplateRef<unknown> = inject(TemplateRef);
  private readonly viewContainerRef: ViewContainerRef = inject(ViewContainerRef);
  private readonly productPriceVisibilityService: ProductPriceVisibilityService = inject(ProductPriceVisibilityService);

  public ngOnInit(): void {
    if (!this.productPriceVisibilityService.arePricesVisible(this.prices())) {
      return;
    }

    this.viewContainerRef.createEmbeddedView(this.templateRef, {
      $implicit: this.prices(),
    });
  }
}
